import Contract from "./contract";
import { ContractSignerType } from "./contractSignerType";

export enum ContractSignatureStatus {
    NotSent = 0,
    Sent = 1,
    Signed = 2,
    Failed = 3,
    Withdrawn = 4
}
export function getContractSignatureStatusText(contract: Contract, isCustomer: boolean = false): string {
    if (!contract) {
        return "";
    }

    if (!isCustomer) {
        switch (contract.eSignatureStatus) {
            case ContractSignatureStatus.NotSent:
                return "Not Sent";
            case ContractSignatureStatus.Sent:
                return contract.eSignatureAwaitingSignerType === ContractSignerType.Merchant ? "Sign Now" : "Sent";
            case ContractSignatureStatus.Signed:
                return "Signed";
            case ContractSignatureStatus.Failed:
                return "Failed";
            case ContractSignatureStatus.Withdrawn:
                return "Withdrawn";
            default:
                return "Unknown";
        }
    }

    switch (contract.eSignatureStatus) {
        case ContractSignatureStatus.Signed:
            return "Signed";
        case ContractSignatureStatus.Sent:
            return "Unsigned";
        default:
            return "Not Ready";
    }
}

export function getContractSignatureStatusTextClass(contract: Contract, isCustomer: boolean = false): string {
    if (!isCustomer) {
        switch (contract?.eSignatureStatus) {
            case ContractSignatureStatus.Failed:
            case ContractSignatureStatus.NotSent:
                return "text-danger";
            case ContractSignatureStatus.Sent:
                return contract.eSignatureAwaitingSignerType === ContractSignerType.Merchant ? "text-danger" : "text-warning";
            case ContractSignatureStatus.Signed:
                return "text-success";
            default:
                return "text-danger";
        }
    }
    switch (contract?.eSignatureStatus) {
        case ContractSignatureStatus.Sent:
            return "text-warning";
        case ContractSignatureStatus.Signed:
            return "text-success";
        default:
            return "text-info";
    }
}